export class SignupMethodTypes {
  static readonly Email = "email";
  static readonly OneClick = "oneclick";
  static readonly Mobile = "mobile";
  static readonly WhatsApp = "whatsapp";
}
